export default {
   API_ENDPOINT: `https://rhubarb-shortcake-42614.herokuapp.com`
}
